export default "__VITE_ASSET__DlwvxPhv__"